import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    filterKey: String,
    defaultValue: String
  }

  connect() {
    this.element.addEventListener("change", this.filterChanged.bind(this))
    this.element.addEventListener("filter:clear", this.clearFilter.bind(this))

    setTimeout(() => {
      this.dispatchInitializedEvent(this.getValue())
    }, 0)
  }

  dispatchInitializedEvent(value) {
    const isDefaultValue = this.hasDefaultValueValue && value === this.defaultValueValue

    const event = new CustomEvent("filter:initialized", {
      detail: {
        label: this.getLabel(),
        value,
        filterKey: this.filterKeyValue,
        isDefaultValue
      }
    })
    this.element.dispatchEvent(event)
  }

  filterChanged() {
    const currentValue = this.getValue()
    const isDefaultValue = this.hasDefaultValueValue && currentValue === this.defaultValueValue
    
    const event = new CustomEvent("filter:change", {
      detail: { 
        label: this.getLabel(), 
        value: currentValue, 
        filterKey: this.filterKeyValue,
        isDefaultValue: isDefaultValue
      }
    })

    this.element.dispatchEvent(event)
  }

  clearFilter() {
    if (this.hasDefaultValueValue) {
      this.element.tomselect.setValue(this.defaultValueValue)
    } else {
      this.element.tomselect.clear()
    }
  }

  getLabel() {
    const value = this.getValue()
    if (!value) return null

    const tomSelectItem = this.element.tomselect.getItem(value)
    if (tomSelectItem) return tomSelectItem.innerHTML

    const originalOption = this.findOriginalOption(value)
    if (originalOption) return originalOption.text

    return value
  }

  findOriginalOption(value) {
    return Array.from(this.element.options).find(opt => opt.value === value)
  }

  getValue() {
    return this.element.tomselect.getValue()
  }
}
